import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  providerIconWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  providerIcon: {
    minWidth: 24,
    maxWidth: 24,
    height: 24
  }
})

export default useStyles
